import { DashboardRouteParams } from '@experiment-management-shared/types';
import { useHistory, useParams } from 'react-router';
import { ViewItemData } from '@shared/components/ViewSelect/utils';
import useBaseTrackEvent from '@shared/hooks/useBaseTrackEvent';
import { dashboardEvents } from '@/constants/trackingEventTypes';
import useSelectedProjectView from '@API/project/useSelectedProjectView';
import { useDashboardApiContext } from '@projects/components/EMDashboardPage/useDashboardAPIContext';
import { AUTO_GENERATED_OPTION_ID } from '@shared/constants';
import { useCallback } from 'react';

const useChangeCurrentView = () => {
  const { data: selectedView } = useSelectedProjectView();
  const baseTrackEvent = useBaseTrackEvent();
  const history = useHistory();
  const { projectName, section, workspace } = useParams<DashboardRouteParams>();
  const { saveTemplateOnServerDebounced } = useDashboardApiContext();

  const changeCurrentView = useCallback(
    (viewId: string) => {
      history.push(`/${workspace}/${projectName}/view/${viewId}/${section}`);
    },
    [history, projectName, section, workspace]
  );

  const onSelectView = useCallback(
    (viewId: string, option: ViewItemData) => {
      saveTemplateOnServerDebounced.flush();

      changeCurrentView(
        option.isAutogenerated ? AUTO_GENERATED_OPTION_ID : viewId
      );

      baseTrackEvent(dashboardEvents.PROJECT_PAGE_SWITCHED_VIEW, {
        before_view_name: selectedView?.templateName ?? 'Auto generated',
        after_view_name: option.name
      });
    },
    [
      baseTrackEvent,
      changeCurrentView,
      saveTemplateOnServerDebounced,
      selectedView?.templateName
    ]
  );

  return {
    changeCurrentView,
    onSelectView
  };
};

export default useChangeCurrentView;
